<template>
  <div>
    <div v-if="is_h5 == false">
      <el-scrollbar wrap-style="overflow-x:hidden;">
        <pheader activeIndex="InternationalTourism"></pheader>
        <div class="pc_index-banner">
          <div class="div" >
            <el-carousel height="300px" :motion-blur=true :autoplay=true :interval='3000'>
              <el-carousel-item v-for="(bImg,idx) in bannerImages" :key="idx">
                <el-image style="height: 300px; width: 100%;" :src="bImg" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <el-container class="pc_index_main">
          <el-main>
            <el-row v-for="(ztjsItem, idx) in item.zhuantijieshaoItems" :key="idx">
              <el-col v-if="ztjsItem.value.length > 0">
                <div :class="'pc_index_main-0'">
                  <div class="pc_index-content">
                    <div class="pc_index-item-title">
                      <div class="pc_index-item-title-content">
                        <div class='title'>
                          {{ ztjsItem.name }}
                        </div>
                      </div>
                    </div>
                    <div style="padding:5px; line-height: 35px;line-height: 35px; font-size: 18px;" v-html="ztjsItem.value">
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row v-for="(obj, idx) in item.topicInfos" :key="idx">
              <el-col v-if="obj.items.length > 0">
                <div :class="'pc_index_main-' + idx%2">
                  <div class="col-content">
                    <div class="pc_index-item-title">
                      <div class="pc_index-item-title-content">
                        <div class='title'>
                          {{ obj.dict_name }}
                        </div>
                      </div>
                    </div>
                    <search-page :searchParam="{'code': item.code, 'type_key': obj.dict_code}" :get_search_page_data="apiUrls['loadSearchPageDataByTopicCode']" ref="searchPageRef"></search-page>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
        <pfooter></pfooter>
      </el-scrollbar>
    </div>
    
    <ai-search-component :isisShow="isisShow"></ai-search-component>
    <div
      class="ibp-h5-ai-fab"
      role="button"
      tabindex="0"
      aria-label="打开课程助手"
      @click="clickAIButton($event)"
      @keydown.enter.prevent="clickAIButton($event)"
    >
      <div class="ibp-h5-ai-fab__inner">
        <el-image class="ibp-h5-ai-fab__img" fit="contain" :src="require('@/assets/hcvt.png')" />
        <p class="ibp-h5-ai-fab__label">课程助手</p>
      </div>
    </div>
  </div>
</template>

<script>
import {showNotify} from 'vant';
import { ref } from 'vue';
import pheader from "@/views/pheader.vue";
import pfooter from "@/views/pfooter.vue";
import aiSearchComponent from "@/components/ai-search-component.vue";
import searchPage from "@/components/search-page.vue";
export default {
  name: 'searchDetail',
  components: {
    pheader,
    pfooter,
    aiSearchComponent,
    searchPage
  },
  props: {

  },
  setup() {
    const loading_h5 = ref(false);
    const apiUrls = {
      'loadCoursesTopicBuTopicCode':'/onlineCodeService/jxzysjfl_api/loadCoursesTopicBuTopicCode',
      'getIndexDataByParent':'/onlineCodeService/jxzysjfl_api/getIndexDataByParent',
      'getIndexDataByIncludeClass':'/onlineCodeService/jxzysjfl_api/getIndexDataByIncludeClass',
      'loadSearchPageDataByTopicCode':'/onlineCodeService/jxzysjfl_api/loadSearchPageDataByTopicCode',
    };
    return {
      loading_h5,
      apiUrls,
    };
  },
  data(){
    return {
      topic_code: 'internationalTourism',
      bannerImages:[],
      is_h5: this.$utils.checkScreenSize(),
      title:'',
      items:[],
      spanValue:4,
      PageSize: 10,
      activeTabs: {},
      activeTabsChildrenItems: {},
      isisShow:0,
      item:{}
    }
  },
  created() {

  },
  methods:{
    clickAIButton(){
      this.isisShow +=1
    },
    handleMore(key){
      let routeUrl = this.$router.resolve({
        path: "/" + key
      });
      window.location.href = routeUrl.href
    },
    windowResize(){
      this.spanValue = this.$utils.calculateSpan()
      this.PageSize = 24 / this.spanValue * 2 / 2
      console.log('windowResize', this.spanValue, this.PageSize)

      if (this.is_h5){
        this.PageSize = 2
      }
      this.initPageSize();
    },
    initPageSize(){
      if (this.PageSize < 0){
        this.PageSize = 10
      }
      this.init()
    },
    init(){
      this.loadCoursesTopicBuTopicCode()
    },
    loadCoursesTopicBuTopicCode(){
      this.loading = true
      this.bannerImages = []
      let param = {'code': this.topic_code, 'count': this.PageSize}
      this.$http.post(this.apiUrls.loadCoursesTopicBuTopicCode, param).then(res => {
        this.loading = false
        if ('0' == res.resultCode) {
          this.item = res.resultData
          this.item.file_infos.forEach(obj=>{
            this.bannerImages.push(window.baseURL + obj.url)
          })

          this.item.topicInfos.forEach(obj=>{
            this.activeTabs[obj.dict_name] = obj.dict_name
          })
        } else {
          this.items = []
          window.vueAlter(res.resultMsg, 'warning')
        }
      }).catch(error => {
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
        this.items = []
        this.loading = false
      })
    },
    toggleMediaDisplay(obj){
      let routeUrl = this.$router.resolve({
        path: "/Detail",
        query: {
          _id:obj._id, 
          title:obj.name
        }
      });
      if (this.is_h5){
        if (obj.open_method == '直接跳转'){
          window.location.href = this.$utils.buildCourseSsoUrl(obj.kc_url, obj.kc_source)
          return false;
        }
        window.location.href = routeUrl.href
      }else{
        if (obj.open_method == '直接跳转'){
          window.open(this.$utils.buildCourseSsoUrl(obj.kc_url, obj.kc_source), '_blank');
          return false;
        }
        this.$utils.windowOpen(routeUrl.href)
      }
    },
    getImageSource(img){
      if (undefined != img && !img.startsWith("http")){
        return this.$utils.getImageSource(img)
      }else{
        return img
      }
    },
    handleTablsClick(tab){
      var _name = tab.props.name
      console.log(_name)
      console.log(this.activeTabsChildrenItems)
      console.log(this.activeTabsChildrenItems[_name.re])
      if (this.activeTabsChildrenItems[_name.replace("/", "_")] && this.activeTabsChildrenItems[_name.replace("/", "_")].length > 0){
        console.log()
      }else{
        let param = {'count': this.PageSize, 'name': _name}
        this.$http.post(this.apiUrls.getIndexDataByIncludeClass, param).then(res => {
          this.loading = false
          if ('0' == res.resultCode) {
            console.log(_name.split("/")[0])
            this.activeTabsChildrenItems[_name.replace("/", "_")] = res.resultData
          } else {
            this.activeTabsChildrenItems[_name.replace("/", "_")] = []
            window.vueAlter(res.resultMsg, 'warning')
          }
        }).catch(error => {
          showNotify('请求失败，请稍后再试！')
          console.log(error)
          console.log('失败')
          this.activeTabsChildrenItems[_name.replace("/", "_")] = []
          this.loading = false
        })
      }
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.windowResize();
    })
    // 添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.windowResize);
  },
  watch: {
    
  }

};
</script>
<style scoped>

.pc_index-banner{
  background-color: #f6f6f6;
}

.pc_index-banner .div{
  max-width: 80%; /* 设置内容区域最大宽度 */
  margin: 0 auto; /* 自动左右边距实现居中 */
}

@media screen and (max-width: 1400px) {
  .pc_index-banner .div{
    max-width: 100%; /* 设置内容区域最大宽度 */
    margin: 0 auto; /* 自动左右边距实现居中 */
  }
}

.pc_index_main-0{
  margin-top: 0px;
  /*background-color: white;*/
  background-color: #f6f6f6;
}

.pc_index_main-1{
  margin-top: 0px;
  background-color: #f6f6f6;
}

.pc_index-content {
  margin: 0 auto; /* 自动左右边距实现居中 */
  max-width: 80%; /* 设置内容区域最大宽度 */
  padding-left: 5px;
  padding-right: 5px;
}

.pc_index-content .col{
  padding-bottom:20px;
}

.pc_index-content .xbox{
  width: 100%;
  aspect-ratio: 1 / 1;
  background: rgb(255, 255, 255);
  border-radius: 10px; /* 设置圆角半径为10px，根据需要调整 */
  cursor: pointer;
}

.pc_index-content .xbox:hover {
  cursor: pointer;
  /* 悬停时的样式，添加阴影效果 */
  box-shadow: rgba(0, 0, 0, 0.07) 0px 0px 9px 6px;
}

.pc_index-content .xbox .text {
  padding: 20px 14px;
  font-size: 12px;
  color: #999;
}
.pc_index-content .xbox .title{
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pc_index-content .xbox .source{
  margin: 11px 0 23px;
}

.pc_text-content {
    color: #969799;
    padding-left: 20px;
    padding-right: 20px;
}

.pc_index-item-title {
    height: 47px;
    font-family: Source Han Sans CN;
    font-weight: 700;
    color: #303030;
    font-size: 32px;
    padding-top: 25px;
    padding-bottom: 15px;
}

.pc_index-item-title-content{
  float: left;
  margin: 5px;
  width: calc(100% - 57px);
  text-align: center;
}


.pc_index-item-title-more {
  cursor: pointer;
  float: right;
  font-size: 12px;
  line-height: 47px;
  color: #999494;
}

.el-main{
  --el-main-padding: 0px;
}

.xbox {
    box-shadow: 6px 9px 3px rgb(123 123 123 / 21%);
}

/* 去除上方横线 */
.tablsSwitch :deep(.el-tabs__nav-wrap::before) {
  content: '';
  width: 0 !important;
}
.tablsSwitch :deep(.el-tabs__nav-wrap::after) {
  content: '';
  width: 0 !important;
}

.tablsSwitch :deep(.el-tabs) {
    --el-tabs-header-height: 47px;
}
/* 去除底部蓝色 
.tablsSwitch :deep(.el-tabs__active-bar) {
  background: rgba(0, 0, 0, 0.1);
  height: 0 !important;
}
*/

.suspended-button{
    --el-backtop-bg-color: var(--el-bg-color-overlay);
    --el-backtop-text-color: var(--el-color-primary);
    --el-backtop-hover-bg-color: var(--el-border-color-extra-light);
    position: fixed;
    background-color: var(--el-backtop-bg-color);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: var(--el-backtop-text-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: var(--el-box-shadow-lighter);
    cursor: pointer;
    z-index: 5;
}
</style>
<style scoped>

.pc_index-item-title-content .title{
    font-size: 20px;
    color: rgb(51, 51, 51);
    text-align: center;
    background: url('../assets/line.png') center 18px no-repeat;
    line-height: 37px;
}

.tabs :deep(.el-tabs__nav-wrap) {
  overflow: hidden;
  position: relative;
  margin-bottom: 0px !important;
}
</style>

<style scoped>

.el-card {
  background-color: unset;
}

.el-carousel__item--card-vertical {
    width: 100%;
    height: 65%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

</style>
<style scoped>
.teacherCard {
  justify-content: center;
  align-items: center;
  width: 100%;
}
.teacherCard img {
  width: 64px; 
  height: 64px; 
  -webkit-border-radius: 50%; 
  border-radius: 50%; 
  margin-top: 24px;
  border: 1px solid #ebebeb;
}

.teacherCard .el-carousel__item--card {
    transition: transform .4s ease-in-out;
}

.swiper-container {
  height: 430px;
}

.swiper-slide {
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-button-prev{
  margin-left: -10px;
}

.swiper-button-next{
  margin-right: -10px;
}

.col-content {
  max-width: 80%; /* 设置内容区域最大宽度 */
  margin: 0 auto; /* 自动左右边距实现居中 */
  padding-left: 5px;
  padding-right: 5px;
}
</style>
